import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";

/**
 * LocalPackages component
 * - Responsive: stacked on small screens, two-column on md+
 * - Left: vehicle list (selectable)
 * - Right: packages for selected vehicle
 *
 * Requires TailwindCSS in the project.
 */

const VEHICLES = [
  {
    id: "Hatchbag",
    name: "Hatchbag",
    packages: [
      { hours: 2, km: 20 },
      { hours: 4, km: 40 },
      { hours: 6, km: 60 },
      { hours: 8, km: 80 },
      { hours: 10, km: 100 },
      { hours: 12, km: 120 },
    ],
  },
  {
    id: "Sedan",
    name: "Sedan",
    packages: [
      { hours: 2, km: 20 },
      { hours: 4, km: 40 },
      { hours: 6, km: 60 },
      { hours: 8, km: 80 },
      { hours: 10, km: 100 },
      { hours: 12, km: 120 },
    ],
  },
  {
    id: "Luxury Sadan",
    name: "Luxury Sadan",
    packages: [
      { hours: 2, km: 20 },
      { hours: 4, km: 40 },
      { hours: 6, km: 60 },
      { hours: 8, km: 80 },
      { hours: 10, km: 100 },
      { hours: 12, km: 120 },
    ],
  },
  {
    id: "Suv",
    name: "Suv",
    packages: [
      { hours: 2, km: 20 },
      { hours: 4, km: 40 },
      { hours: 6, km: 60 },
      { hours: 8, km: 80 },
      { hours: 10, km: 100 },
      { hours: 12, km: 120 },
    ],
  },
  {
    id: "Tempo",
    name: "Tempo",
    packages: [
      { hours: 2, km: 20 },
      { hours: 4, km: 40 },
      { hours: 6, km: 60 },
      { hours: 8, km: 80 },
      { hours: 10, km: 100 },
      { hours: 12, km: 120 },
    ],
  },

  // {
  //   id: "tigor",
  //   name: "Tata Tigor",
  //   packages: [
  //     { hours: 2, km: 20 },
  //     { hours: 4, km: 40 },
  //     { hours: 6, km: 60 },
  //     { hours: 8, km: 80 },
  //     { hours: 10, km: 100 },
  //     { hours: 12, km: 120 },
  //   ],
  // },
  // {
  //   id: "innova",
  //   name: "Toyota Innova",
  //   packages: [
  //     { hours: 2, km: 20 },
  //     { hours: 4, km: 40 },
  //     { hours: 6, km: 60 },
  //     { hours: 8, km: 80 },
  //     { hours: 10, km: 100 },
  //     { hours: 12, km: 120 },
  //   ],
  // },
  // {
  //   id: "innova-crysta",
  //   name: "Toyota Innova Crysta",
  //   packages: [
  //     { hours: 2, km: 20 },
  //     { hours: 4, km: 40 },
  //     { hours: 6, km: 60 },
  //     { hours: 8, km: 80 },
  //     { hours: 10, km: 100 },
  //     { hours: 12, km: 120 },
  //   ],
  // },
  // {
  //   id: "ertiga",
  //   name: "Maruti Suzuki Ertiga",
  //   packages: [
  //     { hours: 2, km: 20 },
  //     { hours: 4, km: 40 },
  //     { hours: 6, km: 60 },
  //     { hours: 8, km: 80 },
  //     { hours: 10, km: 100 },
  //     { hours: 12, km: 120 },
  //   ],
  // },
  // {
  //   id: "xylo",
  //   name: "Mahindra Xylo",
  //   packages: [
  //     { hours: 2, km: 20 },
  //     { hours: 4, km: 40 },
  //     { hours: 6, km: 60 },
  //     { hours: 8, km: 80 },
  //     { hours: 10, km: 100 },
  //     { hours: 12, km: 120 },
  //   ],
  // },
];

export default function Packages() {
  const [selectedId, setSelectedId] = useState(VEHICLES[0].id);

  const selectedVehicle =
    VEHICLES.find((v) => v.id === selectedId) ?? VEHICLES[0];

  return (
    <div
      id="prices"
      className="max-w-8xl  md:px-[50px] lg:px-[120px] py-16    px-4  bg-white "
    >
      <div className="max-w-8xl mx-auto">
        {/* Title */}
        <Fade direction="up" triggerOnce>
          <div className="text-2xl md:text-3xl text-center mb-8 md:mb-10  ">
            <p className="text-sm md:text-[16px] text-gray-900 mb-2 lg:mb-0 md:h-[26px]">
              Local Travel Packages
            </p>
            <h1 className="  content-center    font-bold text-gray-900  md:h-[62px] text-center">
              Local Hourly Packages{" "}
              <span className=" text-2xl md:text-4xl "> (Duration + KM)</span>
            </h1>
          </div>
        </Fade>

        <Fade direction="right" triggerOnce ascade damping={0.2}>
          {/* Grid: left list and right details */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
            {/* Left column: vehicle list */}

            <div className="md:col-span-4">
              <div className="bg-transparent">
                <h2 className="text-sm md:text-[24px]  md:h-[29px] font-semibold text-gray-900 mb-3">
                  Vehicle Type
                </h2>

                {/* Card with list. For long lists on small screens we make it scrollable */}
                <div
                  className="bg-white rounded-lg shadow-sm overflow-hidden border"
                  role="listbox"
                  // aria-label="Vehicle types"
                >
                  <ul className="divide-y">
                    {VEHICLES.map((vehicle) => {
                      const active = vehicle.id === selectedId;
                      return (
                        <li key={vehicle.id}>
                          <button
                            type="button"
                            onClick={() => setSelectedId(vehicle.id)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setSelectedId(vehicle.id);
                              }
                            }}
                            className={`w-full text-left px-4 py-3 text-sm sm:text-base flex items-center transition-colors ${
                              active
                                ? "bg-[#CCA065] text-white md:text-[18px] font-medium" // active background like screenshot
                                : "bg-white text-gray-700 hover:bg-gray-50"
                            }`}
                            // aria-selected={active}
                          >
                            <span className="truncate">{vehicle.name}</span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>

            {/* Right column: packages */}

            <div className="md:col-span-8">
              <h2 className="text-sm md:text-[24px] md:h-[29px] font-semibold text-black mb-3">
                Types Of Packages
              </h2>
              <Fade key={selectedId} triggerOnce={false} cascade damping={0.2}>
                <div className="bg-amber-50 rounded-lg p-6 border border-amber-100">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:gap-6">
                    {/* left: selected vehicle name */}
                    <div className="sm:flex-1 mb-4 sm:mb-0">
                      <p className="text-sm text-gray-500">Selected Vehicle</p>
                      <h3 className="mt-1 text-lg font-semibold text-gray-900">
                        {selectedVehicle.name}
                      </h3>
                    </div>

                    {/* right: packages list */}
                    <div className="sm:flex-1">
                      <ul className="space-y-3">
                        {selectedVehicle.packages.map((pkg, idx) => (
                          <li
                            key={idx}
                            className="flex items-center justify-between rounded-md p-3 border border-amber-100"
                          >
                            <div className="text-sm md:text-[18px] text-black">
                              <span className=" text-sm md:text-[18px]">
                                {pkg.hours} hours
                              </span>
                              <span className="ml-2  text-sm md:text-[18px]">
                                {pkg.km}km
                              </span>
                            </div>
                            <div className="text-sm md:text-[18px] ">
                              package
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Optional: note / CTA area */}
                  {/* <div className="mt-6 text-xs text-gray-500">
                <span>Prices / inclusions vary by vehicle and package. </span>
                <span className="hidden sm:inline">
                  Tap a vehicle on the left to view its packages.
                </span>
              </div> */}
                </div>
              </Fade>
            </div>
          </div>
        </Fade>
        {/* Mobile optimized: horizontal vehicle scroller for faster selection (optional) */}
        {/* <div className="mt-6 md:hidden">
            <p className="text-sm text-gray-600 mb-2">Quick select vehicles</p>
            <div className="flex gap-3 overflow-x-auto pb-2">
              {VEHICLES.map((v) => (
                <button
                  key={v.id}
                  onClick={() => setSelectedId(v.id)}
                  className={`flex-shrink-0 px-3 py-2 rounded-md text-sm whitespace-nowrap ${
                    v.id === selectedId
                      ? " text-gray-900 font-medium"
                      : " text-gray-700"
                  }`}
                >
                  {v.name}
                </button>
              ))}
            </div>
          </div> */}
      </div>
    </div>
  );
}
